import {damsFetch} from "../app/damsFetch";
import {clientLog} from "../clientLog";

/**
 * Tells the backend that this job's failure was shown to its owner (DE-1817), so a reload re-runs the job
 * without counting it again. Never rejects: a failed write is logged and resolves false.
 *
 * @param {string} jobId - The failed job.
 * @returns {Promise<boolean>} True when the backend recorded the mark.
 */
export const markFailureShown = async (jobId) => {
    try {
        const response = await damsFetch('/jobs/file-upload', {
            method: 'POST',
            body: JSON.stringify({action: 'failure-shown', operation: {job_id: jobId}}),
        });
        return response?.marked === true;
    } catch (reason) {
        clientLog('warn', `${jobId} - failure-shown mark not stored (${reason})`, 'fileuploadoperation');
        return false;
    }
};
